import { Box, CheckBox } from '@jfs/ui-new'
import React from 'react'
import { newHeaderMapper } from './Fixtures'
import { styles } from './styles'

interface GridCheckboxInterface {
  data: any
  name: string
  childIndex: number
  mainIndex: number
  stateArray: Array<string>
  isEditMode?: boolean
  item: any
  cardsIndividualCheckChange: (cardType: string, columnName: string, item: any, isSelected: boolean) => void
}

const findIndex = (index: number) => {
  return newHeaderMapper[index + 1]
}

export const NewEmptyCheckboxes = React.memo(
  ({
    data,
    name,
    childIndex,
    mainIndex,
    stateArray,
    isEditMode,
    item,
    cardsIndividualCheckChange,
  }: GridCheckboxInterface) => {
    //Row is child index
    //Column is mainIndex
    let cloneStateArray = [...stateArray] as any

    const onPress = React.useCallback(() => {
      const indexName = findIndex(childIndex) as any
      const valueAtIndex = cloneStateArray[mainIndex][indexName]
      const mUpdatedSelection = !valueAtIndex
      cloneStateArray[mainIndex][indexName] = mUpdatedSelection
      cardsIndividualCheckChange(item?.type, indexName, item, mUpdatedSelection)
    }, [cardsIndividualCheckChange, childIndex, cloneStateArray, item, mainIndex])

    const isRowCheckedForSelectedType = () => {
      return data?.[name]
    }
    return (
      <Box {...styles.checkboxContainer}>
        <Box {...styles.individualCheckbox}>
          <CheckBox
            checked={isRowCheckedForSelectedType()}
            iconSize={20}
            color={isEditMode ? (isRowCheckedForSelectedType() ? 'BLUE_SHADE' : 'GREY_MATTE') : 'DARK_GREY'}
            onChange={onPress}
            disabled={!isEditMode}
          />
        </Box>
      </Box>
    )
  },
)
